import { render } from "./AlatRegister.vue?vue&type=template&id=26b5c5b2&scoped=true"
import script from "./AlatRegister.vue?vue&type=script&lang=js"
export * from "./AlatRegister.vue?vue&type=script&lang=js"

import "./AlatRegister.vue?vue&type=style&index=0&id=26b5c5b2&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b5c5b2"]])

export default __exports__